import { Box, Checkbox, Input, Text } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import SignaturePad from "signature_pad";
import { PDFDocument, rgb ,PDFName} from "pdf-lib";
import CustomButton from "../components/CustomButton";
import { toast } from "react-toastify";
import { getCoordinatesBySupplier } from "./coordinates";
import { getSummeryPage } from "./e-signatureService";
import {
  addSummeryPageToPdf,
  capitalStringWith_,
  UKDateFormat,
} from "../utils/helpers";
const MergedSignPad = ({
  pdfBlob,
  contractPdfBlob,
  loaPdfBlob,
  userName,
  jobTitle,
  currentSupplier,
  updateSignData,
  contract,
}) => {
  const canvasRef = useRef(null);
  const signaturePad = useRef(null);
  const inputRef = useRef(null);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [warnings, setWarnings] = useState([]);
  const [acceptTerms, setAcceptTerms] = useState(false);

  useEffect(() => {
    if (canvasRef.current) {
      window.onresize = resizeCanvas;
      resizeCanvas();
      signaturePad.current = new SignaturePad(canvasRef.current, {
        backgroundColor: "rgba(255, 255, 255, 0)",
        penColor: "black",
      });
    }
    return () => {
      window.onresize = null;
    };
  }, []);
  const resizeCanvas = () => {
    canvasRef.current.width = Math.min(window.innerWidth - 80, 400);
    canvasRef.current.height = Math.min(window.innerWidth - 80, 400) / 2;
  };
  const handleSignatureChange = (e) => {
    const image = new Image();
    image.src = URL.createObjectURL(e.target.files[0]);
    image.onload = () => {
      signaturePad.current.fromDataURL(image.src);
    };
  };
  const clearSignature = () => {
    signaturePad.current.clear();
    inputRef.current.value = "";
  };
  const saveSignature = async () => {
    if (signaturePad.current.isEmpty()) {
      toast.error("Please draw your signature");
      return;
    }

    if (!acceptTerms) {
      toast.error("Please accept the Terms & Conditions to continue");
      return;
    }

    const dataURL = signaturePad.current.toDataURL();
    const signingDate = new Date().toLocaleDateString();
    await previewSignatureOnPDF(dataURL, signingDate);
    handleAccordionClick();
  };

   const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };

  const previewSignatureOnPDF = async (signatureDataURL, signingDate) => {
    try {
      const pdfBytes = await pdfBlob.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      const pageCount = pdfDoc.getPageCount();

      const supplierCoords = getCoordinatesBySupplier(currentSupplier);
      if (!supplierCoords) {
        setErrorMessage(
          `Coordinates not found for supplier: ${currentSupplier}`,
        );
        return;
      }
      for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
        const page = pdfDoc.getPage(pageIndex);
        const { width, height } = page.getSize();
        const isLastPage = pageIndex === pageCount - 1;

        if (!isLastPage && acceptTerms && currentSupplier == "British Gas") {
            page.drawText(".", {
                x:474.50,
                y:280.50,
                size: 45,
                color: rgb(0, 0, 0),
            });
          
        }


        let pageCoords = isLastPage
          ? {
              signature: {
                xPercent: 0.205,
                yPercent: 0.55,
                widthPercent: 0.2,
                heightPercent: 0.05,
              },
              signingDate: { xPercent: 0.65, yPercent: 0.565 },
            }
          : supplierCoords[pageIndex + 1];
        if (!pageCoords) {
          console.warn(
            `No coordinates set for supplier: ${currentSupplier} on page: ${pageIndex + 1}`,
          );
          continue;
        }
        // const pageCoords = supplierCoords[pageIndex + 1]; // Get coordinates for the 1-based page index
        // if (!pageCoords) {
        //     console.warn(`No coordinates set for supplier: ${currentSupplier} on page: ${pageIndex + 1}`);
        //     continue; // Skip to the next page if no coordinates found
        // }
        const signatureImageBytes = await fetch(signatureDataURL).then((res) =>
          res.arrayBuffer(),
        );
        const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
        if (!Array.isArray(pageCoords)) {
          pageCoords = [pageCoords];
        }
        pageCoords.forEach((coord) => {
          page.drawImage(signatureImage, {
            x: width * coord.signature.xPercent,
            y: height * coord.signature.yPercent,
            width: width * coord.signature.widthPercent,
            height: height * coord.signature.heightPercent,
          });
          if (coord.userName) {
            page.drawText(`Name: ${userName}`, {
              x: width * coord.userName.xPercent,
              y: height * coord.userName.yPercent,
              size: 12,
              color: rgb(0, 0, 0),
            });
          }
          if (coord.jobTitle) {
            page.drawText(`Job Title: ${jobTitle}`, {
              x: width * coord.jobTitle.xPercent,
              y: height * coord.jobTitle.yPercent,
              size: 12,
              color: rgb(0, 0, 0),
            });
          }
          if (coord.signingDate) {
            page.drawText(`${signingDate}`, {
              x: width * coord.signingDate.xPercent,
              y: height * coord.signingDate.yPercent,
              size: 12,
              color: rgb(0, 0, 0),
            });
          }
        });
      }
      const merchant = contract.otherInformationData["Merchant Details"];
      const envelopeTitle = capitalStringWith_(
        merchant?.businessDetails?.businessName,
      );
      const envelopeCreated = new Date(contract?.createdAt || new Date());
      const merchantName = [
        merchant.firstName,
        merchant.middleName,
        merchant.lastName,
      ]
        .filter(Boolean)
        .join(" ");
      const summeryPayload = {
        summeryPayload: {
          envelopeTitle: `${envelopeTitle}_-_loa.pdf.pdf`,
          author: "Crystal Utilities Ltd",
          authorEmail: "support@crystalutilities.co.uk",
          envelopeCreated: UKDateFormat(envelopeCreated),
          envelopeId: `${contract.contractId}-${contract.envelopeId}_LOA-${contract.envelopeIdForLOA}`,
          documentTitle: `${envelopeTitle}_-_loa.pdf.pdf`,
          // documentFingerprint: 'bf44dc9f-0dd0-40db-9e1d-ec9250c6e4b0',
          signerName: merchantName,
          signerEmail: merchant.email,
          signerStatusTime: UKDateFormat(new Date()),
          // signatureFingerprint: '33006579-4f30-4afb-bc72-b6a7ce23c583',
          documentHistoryTime: UKDateFormat(new Date()),
          documentHistoryName: merchantName,
        },
      };

      await addSummeryPageToPdf(pdfDoc, summeryPayload, false);


      const signedPdfBytes = await pdfDoc.save();
      const signedPdfBlob = new Blob([signedPdfBytes], {
        type: "application/pdf",
      });
      updateSignData({
        isSuccess: true,
        file: signedPdfBlob,
        message: "Document Signed Successfully",
      });
      const pdfUrl = URL.createObjectURL(signedPdfBlob);
      setPdfPreviewUrl(pdfUrl);
    } catch (error) {
      console.error("Failed to preview signature on PDF", error);
    }
  };

  const handleAccordionClick = (e) => {
    setTimeout(function () {
      window.scrollBy({
        top: 400,
        behavior: "smooth",
      });
    }, 10);
  };
  return (
    <>
      {errorMessage && (
        <div style={{ color: "red", marginBottom: "10px" }}>{errorMessage}</div>
      )}
      {warnings.length > 0 && (
        <div style={{ color: "orange", marginBottom: "10px" }}>
          {warnings.map((warning, index) => (
            <p key={index}>{warning}</p>
          ))}
        </div>
      )}
      <canvas
        ref={canvasRef}
        style={{ border: "1px solid black", padding: "2px" }}
        width={400}
        height={200}
      ></canvas>
      <Text marginTop={"10px"}>or, upload your signature image:</Text>
      <Input
        ref={inputRef}
        type={"file"}
        accept={"image/*"}
        maxWidth={400}
        padding={"4px"}
        marginTop={"10px"}
        onChange={handleSignatureChange}
      />
      <Box mt="20px">
        <Checkbox
          isChecked={acceptTerms}
          onChange={(e) => setAcceptTerms(e.target.checked)}
          colorScheme="blue"
        >
          <Text as="span" fontSize="sm">
            I accept the Terms & Conditions
          </Text>
        </Checkbox>
      </Box>
      <Box
        marginTop={"10px"}
        marginBottom={"80px"}
        maxW={400}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <CustomButton handler={clearSignature} type="secondary">
          Clear
        </CustomButton>
        <CustomButton handler={saveSignature} type="primary">
          Save Signature
        </CustomButton>
      </Box>
      {pdfPreviewUrl && (
        <iframe
          src={pdfPreviewUrl}
          title="PDF Preview"
          width="100%"
          height="600px"
          style={{ border: "1px solid #ccc", marginTop: "20px" }}
        />
      )}
    </>
  );
};
export default MergedSignPad;